const params = { skillId: 'skillId' };

export const route = {
    params,
    patterns: {
        skillDetails: `/skills/:${params.skillId}/skill-details`,
    },
} as const;

export const getSkillDetailsPageUrl = (skillId: string): string =>
    route.patterns.skillDetails.replace(`:${params.skillId}`, skillId);
